// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"cf8b25d3","500":"e642c792","582":"49443fa0"}[chunkId] + ".chunk.js";
};